import React from 'react';
import { ArrowRight, Database, GitCompareArrows, Search } from 'lucide-react';
import { Link } from 'react-router-dom';
import { materialTools } from './materialTools';
import './MaterialToolCards.css';

const icons = {
  'Material Database': Database,
  'Material Finder': Search,
  'Material Comparison': GitCompareArrows,
};

const MaterialToolCards = ({ headingId, heading = 'Choose the material tool for your task.' }) => (
  <section className="materialTools" aria-labelledby={headingId}>
    <h2 id={headingId}>{heading}</h2>
    <div className="materialToolsGrid">
      {materialTools.map(({ title, description, cta, to }) => {
        const Icon = icons[title];
        return (
          <article className="materialToolCard" key={title}>
            <span className="materialToolIcon" aria-hidden="true"><Icon size={22} strokeWidth={1.9} /></span>
            <h3>{title}</h3>
            <p>{description}</p>
            <Link className="materialToolLink" to={to}>{cta}<ArrowRight size={17} strokeWidth={2} aria-hidden="true" /></Link>
          </article>
        );
      })}
    </div>
  </section>
);

export default MaterialToolCards;
